<script lang="ts">
  import { Col } from "sveltestrap";
  import Card from "../../Core/Card.svelte";
  import TestimonialOrder from "./TestimonialOrder.svelte";
</script>

<Col xl="4" class="box-col-6">
  <Card cardProps="testimonial text-center">
    <div slot="contentbody">
      <div class="item">
        <i class="fa fa-quote-left" />
        <p>
          In contrast to prevailing misconceptions, Lorem Ipsum isn't just arbitrary text. It's deeply rooted in a fragment of classical Latin literature from 45 BC, with a history spanning over two millennia. 
          <span>
            Richard McClintock meticulously explored its origins and significance, shedding light on its enduring relevance in the realm of typesetting and design, where it serves as a placeholder text to this day.
          </span>
        </p>
        <img class="img-80" src="../assets/images/dashboard/boy-2.png" alt="" />
        <h5 class="font-primary">Poio klot</h5>
        <span>Developer</span>
      </div>
    </div>
  </Card>
  <TestimonialOrder />
</Col>
